import _ from 'lodash';

const weatherIconMap = {
  d: {
    '01': 'sun',
    '02': 'cloud-sun',
    '03': 'cloud',
    '04': 'cloud',
    '09': 'cloud-showers-heavy',
    10: 'cloud-sun-rain',
    11: 'bolt',
    13: 'snowflake',
    50: 'smog'
  },
  n: {
    '01': 'moon',
    '02': 'cloud-moon',
    '03': 'cloud',
    '04': 'cloud',
    '09': 'cloud-showers-heavy',
    10: 'cloud-moon-rain',
    11: 'bolt',
    13: 'snowflake',
    50: 'smog'
  }
};

class Weather {
  static formatWeather(weatherData) {
    const weather = weatherData.weather[0];
    const weatherIcon = weather.icon;
    const faIcon = weatherIconMap[weatherIcon.slice(-1)][weatherIcon.slice(0, 2)];
    return {
      icon: faIcon,
      description: _.capitalize(weather.description),
      popoverContent: `Description: ${_.capitalize(weather.description)} <br>
                Cloud cover: ${weatherData.clouds.all}% <br>
                Wind: ${weatherData.wind.speed}m/s`
    };
  }

  static formatForecast(forecastData) {
    const windSpeedList = forecastData.list.map(a => a.wind.speed);
    const maxWind = _.round(Math.max(...windSpeedList), 1);
    const avgWind = _.round(_.mean(windSpeedList), 1);
    const maxSafeWind = parseFloat(process.env.VUE_APP_MAX_SAFE_WIND_SPEED);
    return {
      class: maxWind > maxSafeWind ? 'bg-danger' : 'bg-success',
      description: `Max - ${maxWind}m/s`,
      popoverContent: `Average - ${avgWind}m/s`
    };
  }
}

export default Weather;
